import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { LogService } from 'src/app/core/service/log/logservice';

@Component({
  selector: 'app-magic-login',
  templateUrl: './magic-login.component.html',
  styleUrls: ['./magic-login.component.css']
})
export class MagicLoginComponent implements OnInit {

  value3!: string;
  showPassword!: boolean;
  loginForm!: FormGroup;
  submitted = false;
  loading: boolean = false;
  disableBtn: boolean = false;
  hideInputField: boolean = false;
  token: string | null = null;
  url: string | undefined;
  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private logService: LogService,
    private router: Router,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.formInit();
    this.token = this.route.snapshot.queryParams['token'];
  }

  formInit() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      type: "catalogue",
      staySignedIn: false
    });
  }

  get f() {
    return this.loginForm.controls;
  }

  // Login Method
  onLogin() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.loading = true;
    this.disableBtn = true;
    this.logService.magic_login(this.loginForm.value).subscribe(
      (res) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message,
          life: 10000,
        });
        this.hideInputField = true;

        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.disableBtn = false;
      }
    );
  }

}
